import React, { Fragment } from 'react';
import BaseInfo from './Card/BaseInfo.js';
import CardInfoFragment from './Card/CardInfoFragment';
import RelateSchools from './Card/RelateSchools.js';

const labelLayout = {
  xs: { span: 24 },
  md: { span: 10 },
};

const contentLayout = {
  xs: { span: 24 },
  md: { span: 14 },
};

class Index extends React.Component {
  render() {
    return (
      <Fragment>
        <BaseInfo labelLayout={labelLayout} contentLayout={contentLayout} />

        <CardInfoFragment labelLayout={labelLayout} contentLayout={contentLayout} />

        <RelateSchools />
      </Fragment>
    );
  }
}

export default Index;



// WEBPACK FOOTER //
// ./src/routes/Merchant/Business/My/Index.js